import { Checkbox, FormLabel, Textinput } from "shared";
import {
    ITemplateComponent,
    ITemplateMultilineComponent
} from "entities/template";
import React from "react";
import { useComponentsTranslations } from "../../../../lib/i18n";
import { useComponentValidateFunction } from "../../../../lib/hooks/useComponentValidateFunction";
import { VisibilityField } from "../../form_fields/visibility_field/visibility_field";
import { LabelField } from "../../form_fields/label_field/label_field";
import { TooltipField } from "../../form_fields/tooltip_field/tooltip_field";
import styles from "./component_form_multiline.module.scss";

interface IComponentFormMultilineProps {
    component: ITemplateMultilineComponent;
    enLanguageEnabled: boolean;
    componentList: ITemplateComponent[];
    triggerValidate: number;
    onChange: (component: ITemplateComponent) => void;
}

export const ComponentFormMultiline: React.FC<IComponentFormMultilineProps> = React.memo(({
                                                                                              component,
                                                                                              enLanguageEnabled,
                                                                                              componentList,
                                                                                              triggerValidate,
                                                                                              onChange
                                                                                          }) => {
    const t = useComponentsTranslations();
    const { validateTag } = useComponentValidateFunction();

    const onFieldChange = (value: Partial<ITemplateMultilineComponent>) => {
        onChange({
            ...component,
            ...value
        })
    }

    return <div className={styles.container}>
        <LabelField component={component}
                    enLanguageEnabled={enLanguageEnabled}
                    title={t("formLabel")}
                    name="label-dynamic-input"
                    onChange={onFieldChange}/>

        <FormLabel title={t("formTag")} required={true}>
            <Textinput size="m"
                       triggerValidate={triggerValidate}
                       validate={true}
                       validateFunc={validateTag}
                       value={component.name ? component.name : ""}
                       onChange={(e) => onFieldChange({ name: e.target.value })}
                       view="outline"/>
        </FormLabel>

        <VisibilityField
            component={component}
            componentList={componentList}
            onChange={onFieldChange}/>

        <TooltipField
            component={component}
            enLanguageEnabled={enLanguageEnabled}
            onChange={onFieldChange}
        />

        <div className={styles.checkboxGroup}>
            <Checkbox
                label={t("requiredField")}
                size="m"
                onChange={() => onFieldChange({ required: typeof component.required === "boolean" ? !component.required : false })}
                checked={typeof component.required === "boolean" ? component.required : true}
            />
            <Checkbox
                label={t("rowGroup")}
                size="m"
                onChange={() => onFieldChange({ isRowGroup: !component.isRowGroup })}
                checked={component.isRowGroup}
            />
        </div>

    </div>;
});

